import React from 'react';
import './BlogCard.css';

const BlogCard = ({ image, category, title, excerpt, date, link }) => {
  return (
    <article className="blog-card">
      <img src={image} alt={title} />
      <div className="blog-content">
        <h3>{title}</h3>
        <p>{excerpt}</p>
      </div>
    </article>
  );
};

export default BlogCard;
